import { connect } from 'react-redux';
import { getTaskListRequest } from './task-list-actions';
import Tasklist from '../components/task-list';

const mapStateToProps = state => ({
  taskList: state.order.taskLists.taskList,
  isLoading: state.order.taskLists.isLoading,
});

const mapDispatchToProps = { getTaskListRequest };

export default connect(mapStateToProps, mapDispatchToProps)(Tasklist);
